module.exports = __webpack_public_path__ + "static/media/Shopping-cart.fb9d720b.svg";